import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_URL
} from '../Variables';

let clientFactory = new ApiClientFactory();

export const NotificationsClient = {

    getNotifications() {
        return clientFactory.get(API_URL + 'notifications');
    },
    markNotificationAsRead(notificationIds) {
        return clientFactory.put(API_URL + 'notifications', {
            notificationIds: notificationIds,
            is_read: 1
        })
    },
    markNotificationAsSeen(notificationIds) {
        return clientFactory.put(API_URL + 'notifications', {
            notificationIds: notificationIds,
            is_seen: 1
        })
    }

};